export default "__VITE_ASSET__CXq6Qu1Z__"